import Icon from '@forwardflow/ui/Icons'
import { FC } from 'react'

interface UserListItemProps {
   user: any
   isSelected: boolean
   onUserSelect: (user: any) => void
}

const UserListItem: FC<UserListItemProps> = ({
   user,
   isSelected,
   onUserSelect,
}) => {
   return (
      <div
         className="flex items-center cursor-pointer bg-[#828282] bg-opacity-20 border text-[14px] border-white/20 py-4 px-[22px] rounded-lg"
         onClick={() => onUserSelect(user)}
      >
         <span
            className={`w-4 h-4 flexc rounded-full inline-block shrink-0 mr-4 ${
               isSelected ? 'bg-primary' : 'bg-[#828282]'
            }`}
         >
            {isSelected && (
               <Icon name="Check" className="w-full h-full flexc" width={8} />
            )}
         </span>
         <span className="flex flex-col items-start flex-1 gap-1 mr-2">
            <span> {user.firstName}</span>
            {user.isAdmin === true && (
               <span className="text-[8px] uppercase font-semibold bg-primary py-[3px] px-2 rounded">
                  Account Manager
               </span>
            )}
         </span>
         <div className="flex flex-col text-white/70 w-[60%]">
            <span className="flex-1 pr-3 overflow-hidden text-ellipsis">
               {user.email}
            </span>
            <span>{user.phone}</span>
         </div>

         {/* <Tooltip title="Edit user contact details before sending the invite.">
            <div
               onClick={(e) => {
                  e.stopPropagation(), openUpdateUserDetailsModal()
               }}
            >
               <Icon
                  name="Edit"
                  className="transition-all scale-125 fill-white opacity-70 hover:opacity-100"
               />
            </div>
         </Tooltip> */}
      </div>
   )
}

export default UserListItem
